import request from '@utils/axios-utils';
import { useQuery } from 'react-query';
import { Webhook, ApiObject } from '@types';
import { useAuth } from '@providers/auth';

export function useWebhooks() {
  const { session } = useAuth();
  return useQuery<ApiObject<Webhook[]>>(
    'webhooks',
    async () => {
      const response = await request({
        authorizationToken: session?.token,
        url: `/webhooks`,
        method: 'GET',
      });
      return response.data;
    },
    {
      enabled: session.status != 'loading',
    },
  );
}
